module.exports = __webpack_public_path__ + "static/media/sheild.edd8da31_UI.svg";